import Vue from 'vue';

export default () => {
	const notifySuccess = (message, timeout = 10000, type = 'default') => {
		Vue.prototype.$notify({
			message,
			timeout,
			icon: (type == 'success') ? 'ni ni-check-bold' : 'ni ni-bell-55',
			type: type,
		});
	}
	const notifyError = (message, timeout = 10000, type = 'warning') => {
		Vue.prototype.$notify({
			message,
			timeout,
			icon: 'ni ni-bulb-61',
			type: type,
		});
	}
	const redErrorNotify = (error_message) => {
		notifyError(error_message, 1000, 'danger')
	}
	const errorFunction = (error, message = null, module = null) => {
		if (error == 403) {
			notifyError("You dont have Access to this Module or Function in the Module. Please Contact Administrator.")
			return
		}
		if (!_gHlp.isEmpty(message)) {
			notifyError(message)
			return
		}

		//ERROR RESPONSE
		if (!_gHlp.isEmpty(error)) {

			if (!_gHlp.isEmpty(error.response)) {
				let response_code = (!_gHlp.isEmpty(error.response.status)) ? error.response.status : null;
				let response_data = (!_gHlp.isEmpty(error.response.data)) ? error.response.data : null;
				let response_errors = (!_gHlp.isEmpty(response_data) && !_gHlp.isEmpty(response_data.errors)) ? response_data.errors : null;

				//IF HAS ERROR ARRAY
				if (!_gHlp.isEmpty(response_errors)) {
					let errorList = '<br>'
					let noError = 0
					Object.keys(response_errors).forEach(function (key) {
						Object.keys(response_errors[key]).forEach(function (value) {
							noError = noError + 1
							errorList = errorList + 'No. ' + noError + ' : ' + (response_errors[key][value])
							errorList = errorList + '<br>'
						});
					});

					notifyError('<b>Input Validation Warning :  </b>  ' + errorList)
					return;
				}

				if (response_code == 401) {
					notifyError('<b>System Warning : </b> - Your session has been end, please re-login.', 15000, 'danger');
					return;
				}
				//IF SERVER ERROR
				if ((response_code === 500) && !_gHlp.isEmpty(response_data)) {

					if (!_gAuth.appIsDemo()) {
						notifyError('<b>System Error : </b> - The System is Currently Busy or Un-Available.', 15000, 'danger');
						return;
					}

					let { message, file, line } = response_data;
					var error = message
					if (file && line) {
						error = message + '<br> File: ' + file.split("/").pop() + '<br>Line: ' + line
					}
					notifyError(error)
					return;
				}

				//NO HAVE PERMISSION
				if (response_code == 403) {
					if (!_gHlp.isEmpty(module)) {
						notifyError('<b>Insufficient Permissions to : ' + module + '</b> - You dont have Access to this Module or Function in the Module. Please Contact Administrator.')
						return;
					} else {
						notifyError('<b>Insufficient Permissions</b> - You dont have Access to this Module or Function in the Module. Please Contact Administrator.')
						return;
					}
				}

				if (response_code == 404) {
					if (!_gHlp.isEmpty(module)) {
						notifyError('<b>Try request to : ' + module + '</b> - The data you requested is not available')
						return;
					} else {
						notifyError('<b>No Available Services</b> - The data you requested is not available.')
						return;
					}
				}

				//IF NOTFOUND
				if ((response_code >= 400) && !_gHlp.isEmpty(response_data)) {
					if (!_gHlp.isEmpty(response_data.message)) {
						notifyError(response_data.message)
						return;
					}
					if (_gHlp.isEmpty(response_data.message) && !_gHlp.isEmpty(response_data.exception)) {
						notifyError(response_data.exception)
						return;
					}
					if (!_gHlp.isEmpty(error.message)) {
						notifyError(error.message)
						return;
					}
				}

				//IF UNKNOW ERROR
				if (!_gHlp.isEmpty(response_data)) {
					if (!_gHlp.isEmpty(response_data.message)) {
						notifyError(response_data.message)
					} else {
						notifyError("Something went wrong!. Please Contact Administrator.")
					}
					return;
				}
			}
			if (!_gHlp.isEmpty(error.message)) {
				notifyError(error.message)
				return
			}

			if (_gHlp.isEmpty(error.response)) {
				notifyError("Something went wrong!. Please Contact Administrator.")
				return
			}
		}
	}
	const underDevelopment = () => {
		notifyError('<b>This Function / Module is currently Under Development, Please come back later.</b>')
	}
	const cLog = (message) => {
		if (_gAuth.appIsDemo()) console.log(message);
	}
	const generateBellNotif = (trigger, data, template = '') => {
		
		let user_pos = '';
		if(_gHlp.checkAccess(['role_credit_manager'])){
			user_pos = 'Credit Manager';
		}else if(_gHlp.checkAccess(['role_credit_head'])){
			user_pos = 'Credit Manager';
		}else if(_gHlp.checkAccess(['role_loan_officer'])){
			user_pos = 'Loan Officer';
		}else if(_gHlp.checkAccess(['role_admin','role_super_admin'])){
			user_pos = 'Admin';
		}

		data['user_pos'] = user_pos;
		data['user_name'] =  _gAuth.activeUser('name');
			
		let notif_params = {}
		switch (trigger) {
			case 'LMS_LOAN_EC_SUBMIT_APPROVAL':{
				if(_gHlp.isEmpty(template)){
					template = "Pending Proposal: customer {customer_name} has been submitted for approval by {user_name}"
				}
				notif_params = {
					noti_message: _gHlp.replacePlaceholders(template,data),
					noti_url: window.location.origin +'/customer/pending-customer-detail/'+data.customer_id+'?lec_id='+data.id+'&psal_id=' + data.psal_id,
					microservice_code: 'invinity',
					noti_related_type: 'loan_ec',
					noti_related_id: data.id
				}
				break;
			}
			case 'LMS_LOAN_EC_REJECT':{
				if(_gHlp.isEmpty(template)){
					template = "Pending Proposal: customer {customer_name} has been rejected by {user_name}"
				}
				notif_params = {
					noti_message: _gHlp.replacePlaceholders(template,data),
					noti_url: window.location.origin +'/customer/pending-customer-detail/'+data.customer_id+'?lec_id='+data.id+'&psal_id=' + data.psal_id,
					microservice_code: 'invinity',
					noti_related_type: 'loan_ec',
					noti_related_id: data.id
				}
				break;
			}
			case 'LMS_LOAN_EC_CANCEL':{
				if(_gHlp.isEmpty(template)){
					template = "Pending Proposal: customer {customer_name} has been canceled by {user_name}"
				}
				notif_params = {
					noti_message: _gHlp.replacePlaceholders(template,data),
					noti_url: window.location.origin +'/customers-list/pending-acceptance',
					microservice_code: 'invinity',
					noti_related_type: 'loan_ec',
					noti_related_id: data.id
				}
				break;
			}
			case 'LMS_LOAN_EC_APPROVED':{
				if(_gHlp.isEmpty(template)){
					template = "Pending Proposal: customer {customer_name} has been approved by {user_name}"
				}
				notif_params = {
					noti_message: _gHlp.replacePlaceholders(template,data),
					noti_url: window.location.origin +'/customer/customer-detail/'+data.customer_id,
					microservice_code: 'invinity',
					noti_related_type: 'customer',
					noti_related_id: data.customer_id
				}
				break;
			}
			case 'LMS_CASE_UPDATE_REQUEST':{
				if(_gHlp.isEmpty(template)){
					template = "Loan Case: customer {customer_name} request approval for editing detail by {user_name}"
				}
				notif_params = {
					noti_message: template.replace('{customer_name}', data.customer_name).replace('{user_pos}', user_pos).replace('{user_name}', _gAuth.activeUser('name')),
					noti_url: window.location.origin +'/credit-loan-case/detail/'+data.case_id+'?active=overview',
					microservice_code: 'invinity',
					noti_related_type: 'loan_case',
					noti_related_id: data.case_id
				}
				break;
			}
			case 'LMS_CASE_UPDATE_APPROVAL':{
				if(_gHlp.isEmpty(template)){
					template = "Loan Case: customer {customer_name} request editing detail has been {action} by {user_name}"
				}
				notif_params = {
					noti_message: template.replace('{customer_name}', data.customer_name).replace('{user_pos}', user_pos).replace('{user_name}', _gAuth.activeUser('name')).replace('{action}', data.action),
					noti_url: window.location.origin +'/credit-loan-case/detail/'+data.case_id+'?active=overview',
					microservice_code: 'invinity',
					noti_related_type: 'loan_case',
					noti_related_id: data.case_id
				}
				break;
			}
			case 'LMS_CASE_DISBURSEMENT_REQUEST':{
				if(_gHlp.isEmpty(template)){
					template = "Disbursement: customer {customer_name} request disbursement approval by {user_name}"
				}
				notif_params = {
					noti_message: _gHlp.replacePlaceholders(template,data),
					noti_url: window.location.origin +'/credit-loan-case/detail/'+data.case_id+'?active=disbursement',
					microservice_code: 'invinity',
					noti_related_type: 'loan_case',
					noti_related_id: data.case_id
				}
				console.log(notif_params);
				break;
			}
			case 'LMS_CASE_DISBURSEMENT_APPROVAL':{
				if(_gHlp.isEmpty(template)){
					template = "Disbursement: customer {customer_name} disbursement approval has been {action} by {user_name}"
				}
				notif_params = {
					noti_message: template.replace('{customer_name}', data.customer_name).replace('{user_pos}', user_pos).replace('{user_name}', _gAuth.activeUser('name')).replace('{action}', data.action),
					noti_url: window.location.origin +'/credit-loan-case/detail/'+data.case_id+'?active=disbursement',
					microservice_code: 'invinity',
					noti_related_type: 'loan_case',
					noti_related_id: data.case_id
				}
				break;
			}
			case 'LMS_CASE_COLLECTION_REQUEST':{
				if(_gHlp.isEmpty(template)){
					template = "Collection: customer {customer_name} request change collection status by {user_name}"
				}
				notif_params = {
					noti_message: template.replace('{customer_name}', data.customer_name).replace('{user_pos}', user_pos).replace('{user_name}', _gAuth.activeUser('name')),
					noti_url: window.location.origin +'/credit-loan-case/detail/'+data.case_id+'?active=collection',
					microservice_code: 'invinity',
					noti_related_type: 'loan_case',
					noti_related_id: data.case_id
				}
				break;
			}
			case 'LMS_CASE_COLLECTION_APPROVAL':{
				if(_gHlp.isEmpty(template)){
					template = "Collection: customer {customer_name} change status has been {action} by {user_name}"
				}
				notif_params = {
					noti_message: template.replace('{customer_name}', data.customer_name).replace('{user_pos}', user_pos).replace('{user_name}', _gAuth.activeUser('name')).replace('{action}', data.action),
					noti_url: window.location.origin +'/credit-loan-case/detail/'+data.case_id+'?active=collection',
					microservice_code: 'invinity',
					noti_related_type: 'loan_case',
					noti_related_id: data.case_id
				}
				break;
			}
			default: {
				if(!_gHlp.isEmpty(template)){
					notif_params = {
						noti_message: _gHlp.replacePlaceholders(template,data),
						noti_url: _gHlp.getValue(data,'noti_url',null),
						microservice_code: 'invinity',
						noti_related_type: _gHlp.getValue(data,'noti_related_type',null),
						noti_related_id: _gHlp.getValue(data,'noti_related_id',null),
					}
				}
				break;
			}
		}

		return notif_params;
	}
	const generateEmailContent = (trigger, data) => {
    let user_pos = '';
    
    // Determine the user role
    if (_gHlp.checkAccess(['role_credit_manager'])) {
        user_pos = 'Credit Manager';
    } else if (_gHlp.checkAccess(['role_credit_head'])) {
        user_pos = 'Credit Head';
    } else if (_gHlp.checkAccess(['role_loan_officer'])) {
        user_pos = 'Loan Officer';
    } else if (_gHlp.checkAccess(['role_admin', 'role_super_admin'])) {
        user_pos = 'Admin';
    }

    data['user_pos'] = user_pos;
    data['user_name'] = _gAuth.activeUser('name');
    
    let subject = '';
    let body = '';

    switch (trigger) {
        case 'LMS_LOAN_EC_SUBMIT_APPROVAL': {
            subject = "Pending loan eligible request for approval";
            body = `Hello ${data.user_pos} ${data.user_name},<br><br>`;
            body += `A loan eligible for customer ${data.customer_name} has been submitted for approval.<br>`;
            body += `Please review the loan eligible and approve or reject it.<br>`;
            body += `<a href="${window.location.origin}/customer/pending-customer-detail/${data.customer_id}?lec_id=${data.id}&psal_id=${data.psal_id}">View Proposal</a>`;
            break;
        }

        case 'LMS_LOAN_EC_REJECT': {
           	subject = "Loan eligible approval has been rejected";
            body = `Hello ${data.user_pos} ${data.user_name},<br><br>`;
            body += `The loan proposal for customer ${data.customer_name} has been rejected.<br>`;
            body += `You can review the proposal details here:<br>`;
            body += `<a href="${window.location.origin}/customer/pending-customer-detail/${data.customer_id}?lec_id=${data.id}&psal_id=${data.psal_id}">View Proposal</a>`;
            break;
        }

        case 'LMS_LOAN_EC_CANCEL': {
            subject = "Loan eligible has been cancelled";
            body = `Hello ${data.user_pos} ${data.user_name},<br><br>`;
            body += `The loan proposal for customer ${data.customer_name} has been canceled.<br>`;
            body += `For more details, visit the pending proposals list:<br>`;
            body += `<a href="${window.location.origin}/customers-list/pending-acceptance">View Pending Proposals</a>`;
            break;
        }

        case 'LMS_LOAN_EC_APPROVED': {
            subject = "Loan eligible approval has been approved";
            body = `Hello ${data.user_pos} ${data.user_name},<br><br>`;
            body += `The loan proposal for customer ${data.customer_name} has been approved.<br>`;
            body += `You can view the customer details here:<br>`;
            body += `<a href="${window.location.origin}/customer/customer-detail/${data.customer_id}">View Customer</a>`;
            break;
        }

        case 'LMS_CASE_UPDATE_REQUEST': {
            subject = "Loan case request approval for data change";
            body = `Hello ${data.user_pos} ${data.user_name},<br><br>`;
            body += `The loan case for customer ${data.customer_name} is requesting approval for editing their details.<br>`;
            body += `Please review the case using the link below:<br>`;
            body += `<a href="${window.location.origin}/credit-loan-case/detail/${data.case_id}?active=overview">View Loan Case</a>`;
            break;
        }

        case 'LMS_CASE_UPDATE_APPROVAL': {
            subject = `Loan case data change ${data.action}`;
            body = `Hello ${data.user_pos} ${data.user_name},<br><br>`;
            body += `The loan case for customer ${data.customer_name} has been ${data.action} by {user_name}.<br>`;
            body += `You can review the case details here:<br>`;
            body += `<a href="${window.location.origin}/credit-loan-case/detail/${data.case_id}?active=overview">View Loan Case</a>`;
            break;
        }

        case 'LMS_CASE_DISBURSEMENT_REQUEST': {
            subject = "Loan case request disbursement approval";
            body = `Hello ${data.user_pos} ${data.user_name},<br><br>`;
            body += `The loan case for customer ${data.customer_name} is requesting disbursement approval.<br>`;
            body += `You can review the disbursement details here:<br>`;
            body += `<a href="${window.location.origin}/credit-loan-case/detail/${data.case_id}?active=disbursement">View Loan Case</a>`;
            break;
        }

        case 'LMS_CASE_DISBURSEMENT_APPROVAL': {
            subject = `Loan case request disbursement has been ${data.action}`;
            body = `Hello ${data.user_pos} ${data.user_name},<br><br>`;
            body += `The disbursement for customer ${data.customer_name} has been ${data.action} by {user_name}.<br>`;
            body += `You can review the disbursement details here:<br>`;
            body += `<a href="${window.location.origin}/credit-loan-case/detail/${data.case_id}?active=disbursement">View Loan Case</a>`;
            break;
        }

        case 'LMS_CASE_COLLECTION_REQUEST': {
						subject = "Loan case request collection status change approval";
            body = `Hello ${data.user_pos} ${data.user_name},<br><br>`;
            body += `The loan case for customer ${data.customer_name} is requesting a change in collection status.<br>`;
            body += `You can review the collection request here:<br>`;
            body += `<a href="${window.location.origin}/credit-loan-case/detail/${data.case_id}?active=collection">View Loan Case</a>`;
            break;
        }

        case 'LMS_CASE_COLLECTION_APPROVAL': {
						subject = `Loan case collection status change has been ${data.action}`;
            body = `Hello ${data.user_pos} ${data.user_name},<br><br>`;
            body += `The collection status for customer ${data.customer_name} has been ${data.action} by {user_name}.<br>`;
            body += `You can review the collection status here:<br>`;
            body += `<a href="${window.location.origin}/credit-loan-case/detail/${data.case_id}?active=collection">View Loan Case</a>`;
            break;
        }

        default: {
            break;
        }
    }

    return {
			subject:subject,
			body:body
		} // Return the email content (body)
	}

	return {
		notifySuccess,
		notifyError,
		redErrorNotify,
		errorFunction,
		underDevelopment,
		generateBellNotif,
		generateEmailContent,
		cLog
	}
}

